module.exports = __webpack_public_path__ + "media/news/blog-mobile-bcd03bd6.png";